
































































































import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import HelperModule from "@abaco/helper-module/src/modules/helper-module";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";
import { FromStore } from "@abaco/web-common/src/app";
import {
    AbacoWebModule,
    MenuItem,
    NavBarFilter,
} from "@abaco/web-common/src/app/Application";
import { BaseUser } from "@abaco/web-common/src/BaseUser";
import { Vue, Component, Inject, Watch } from "vue-property-decorator";
import MenuModule, {
    MenuItemWithOrd,
} from "@abaco/menu-module/src/modules/menu";
import DemoColdirettiPopUpModule from "@abaco/user-module/src/modules/demoColdirettiPopUp/index";
import HeaderFerreroSideButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderFerreroSideButton.vue";
import HeaderFarmerMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderFarmerMainButton.vue";
import Header4GrapesMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/Header4GrapesMainButton.vue";
import HeaderFerreroMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderFerreroMainButton.vue";
import HeaderMaltaMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderMaltaMainButton.vue";
import HeaderMaltaPmPMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderMaltaPmPMainButton.vue";
import HeaderGenericMainButton from "@abaco/dashboard-module/src/modules/dashboard/components/header/HeaderGenericMainButton.vue";

const PARTNERLIST = [
    "COLDIRETTI",
    "ASNACODI",
    "IBF",
    "SMARTAGRI",
    "UNAPROL",
    "ONT-DEMETRA",
    "BIRRA",
];
const navBarFilterOrder = [
    "campaign-select-nav-bar-item",
    "farm-select-nav-bar-item",
];

@Component({
    components: {
        HeaderFerreroSideButton,
        HeaderFarmerMainButton,
        Header4GrapesMainButton,
        HeaderFerreroMainButton,
        HeaderMaltaMainButton,
        HeaderMaltaPmPMainButton,
        HeaderGenericMainButton,
    },
})
export default class Home extends Vue {
    @Inject(SSOModule.MODULE_ID) ssoModule!: SSOModule;
    @Inject(HelperModule.MODULE_ID) helperModule!: HelperModule;
    @Inject(DashboardModule.MODULE_ID) dashboardModule!: DashboardModule;
    @Inject(MenuModule.MODULE_ID) menuModule!: MenuModule;
    @Inject(DemoColdirettiPopUpModule.MODULE_ID)
    demoColdirettiPopUpModule!: DemoColdirettiPopUpModule;

    @FromStore(SSOModule.MODULE_ID) user!: BaseUser;
    @FromStore(MenuModule.MODULE_ID) menu!: MenuItemWithOrd[];
    @FromStore(MenuModule.MODULE_ID) homePage!: MenuItem;
    @FromStore(DemoColdirettiPopUpModule.MODULE_ID) showDemoModal!: boolean;
    @FromStore(DemoColdirettiPopUpModule.MODULE_ID)
    hasBeenAlreadyOpenedOneTime!: boolean;

    private hasSecondaryNavbar =
        process.env.VUE_APP_HORIZONTAL_MENU != undefined &&
        process.env.VUE_APP_HORIZONTAL_MENU != "false"
            ? true
            : false;
    private hasCompactSidebarMenu =
        process.env.VUE_APP_COMPACT_SIDEBAR_MENU != undefined &&
        process.env.VUE_APP_COMPACT_SIDEBAR_MENU != "false"
            ? true
            : false;
    private showSidebar = false;
    private logoList: string[] = [];

    get filters(): NavBarFilter[] {
        const meta = this.$route.meta;
        const filters: NavBarFilter[] = meta?.navbarItems || [];

        navBarFilterOrder.forEach((nf) => {
            const filterToBeMovedIndex = filters.findIndex((f) =>
                "string" === typeof f ? f === nf : f.component === nf
            );
            const filterToBeMoved = filters.splice(filterToBeMovedIndex, 1);
            filters.push(...filterToBeMoved);
        });
        return filters;
    }

    private get isPortalR2U() {
        return this.ssoModule.environment === "r2u";
    }
    private get isPortal4Grapes() {
        return this.ssoModule.environment === "a4grapes";
    }
    private get isPortalFarmer() {
        return (
            this.logoList.length === 1 &&
            this.logoList[0] === process.env.BASE_URL + "img/logo_abaco.png"
        );
    }
    private get isPortalFerreroOutGrower() {
        return process.env.VUE_APP_MODE === "ferrero-outgrower";
    }
    private get isPortalFerreroCounting() {
        return process.env.VUE_APP_MODE === "ferrero-counting";
    }
    private get isPortalFerrero() {
        return this.ssoModule.environment === "PORTAL_FERRERO";
    }
    private get isPortalMalta() {
        return this.ssoModule.environment === "malta";
    }
    private get isPortalMaltaPmP() {
        return this.ssoModule.environment === "malta-pmp";
    }
    private get isPortalColdirettiDemo() {
        return this.ssoModule.environment === "coldiretti-demo";
    }
    private get isColdiretti() {
        return this.ssoModule.environment.includes("coldiretti");
    }
    private get isPortalNIAB() {
        return this.ssoModule.environment === "niab";
    }

    async created() {
        if (!this.isBrowserSupported()) {
            alert("Your browser is not supported, plese update to a newer one");
        }

        const dataMode = this.ssoModule.environment == "niab" ? "portal" : this.ssoModule.environment;
        document.documentElement.setAttribute(
            "data-mode",
            dataMode
        );

        this.populateLogoList();
        if (this.$route.path !== "/") {
            this.hasBeenAlreadyOpenedOneTime = true;
            return;
        }

        if (this.isPortalR2U) {
            const needsHelp = await this.helperModule.needsHelp(
                this.user.isBasic
            );

            if (needsHelp) {
                this.$router.push({ name: "helper" });
                return;
            }
        }

        if (!this.homePage) {
            await this.menuModule.loadMenu();
        }

        this.navigateToHome();
    }

    @Watch("showDemoModal")
    private navigateToHome() {
        if (
            !this.homePage ||
            (this.demoColdirettiPopUpModule &&
                (this.hasBeenAlreadyOpenedOneTime || this.showDemoModal))
        ) {
            return;
        }
        if (this.demoColdirettiPopUpModule) {
            this.hasBeenAlreadyOpenedOneTime = true;
        }
        this.menuModule.navigateToMenu(this.homePage);
    }

    private isBrowserSupported(): boolean {
        // const ua = window.navigator.userAgent;
        // const msie = ua.indexOf("MSIE ") === -1;
        // const isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
        // return !msie && !isIE11;
        return !/Trident\/|MSIE/.test(window.navigator.userAgent);
    }

    private async populateLogoList() {
        if (!process.env.VUE_APP_MODE?.includes("coldiretti")) {
            this.logoList = [
                process.env.BASE_URL +
                    (process.env.VUE_APP_LOGO || "img/logo_abaco.png"),
            ];
            return;
        }
        this.logoList.push(process.env.BASE_URL + `img/logo_demetra.png`);
        for (const partner of PARTNERLIST) {
            if (
                await this.ssoModule.isFunctionEnabled(
                    "PORTAL_USER",
                    `${partner}_PARTNER`
                )
            ) {
                this.logoList.push(
                    process.env.BASE_URL +
                        `img/logo_${partner.toLowerCase()}.png`
                );
            }
        }
    }
}
